var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-datalist dropdown",class:_vm.cssClass,style:(_vm.cssStyle)},[_vm._t("header"),_c('ul',{ref:"ul",staticClass:"list",style:(_vm.cssListStyle)},[_vm._l((_vm.options),function(option,index){return _vm._t("option",function(){return [_c('li',{key:index,class:{ active: index == _vm.cursorIndex },on:{"click":function($event){return _vm.onOptionClick(option, index)}}},[_c('div',{staticClass:"text-truncate",staticStyle:{"min-height":"calc(var(--line-height) * 1rem)"}},[_vm._t("option-label",function(){return [_vm._v(" "+_vm._s(option)+" ")]},null,{
                            option,
                            index,
                            cursorIndex: _vm.cursorIndex,
                            setCursorIndex: _vm.setCursorIndex
                        })],2)])]},null,{
                option,
                index,
                cursorIndex: _vm.cursorIndex,
                setCursorIndex: _vm.setCursorIndex,
                select: () => _vm.onOptionClick(option, index)
            })})],2),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }